var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "header-back-link",
    attrs: {
      "title": "Назад"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'cabinet'
        });
      }
    }
  }), _c('div', {
    staticClass: "header-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('work.like.self.employed'))
    }
  })]), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '############',
      expression: "'############'"
    }],
    attrs: {
      "input-id": "self-employed-inn",
      "input-name": _vm.$t('common.inn'),
      "input-placeholder": _vm.$t('enter.inn.number'),
      "min-length": 12,
      "max-length": 12,
      "data-private": "",
      "required": ""
    },
    model: {
      value: _vm.inn,
      callback: function callback($$v) {
        _vm.inn = $$v;
      },
      expression: "inn"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+7##########',
      expression: "'+7##########'"
    }],
    attrs: {
      "input-id": "self-employed-phone",
      "input-name": _vm.$t('phone.number.only.rf'),
      "input-placeholder": "+71234567890",
      "min-length": 12,
      "max-length": 12,
      "data-private": "",
      "required": ""
    },
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('self.employed.privacy.policy', {
        getUserAgreementLinkBySelfEmployed: _vm.getUserAgreementLinkBySelfEmployed
      }))
    }
  })]), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "button-send"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.handlerOnRegistration
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('accept.status')) + " ")])]), _c('div', {
    staticClass: "text-information"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('get.self.employed.status.on.fns.site.or.app'))
    }
  }), _c('p', [_c('a', {
    attrs: {
      "href": "https://help.capusta.space/samozanyatoy_npd",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.details')))])])]), _c('div', {
    staticClass: "button-link-container"
  }, [_c('a', {
    attrs: {
      "href": "https://npd.nalog.ru/web-app/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('fns.site')))])]), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.gnivts.selfemployed&hl=ru",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('for.android')))])]), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BD%D0%B0%D0%BB%D0%BE%D0%B3/id1437518854?l=en",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('for.iphone')))])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }